/*
sai krishna 01/19/2023 2698088984 added  table for view candidates
Ashraf 01/25/2023 2699962131, 2699932578 fixed routing issues, added delete action
Ashraf 01/25/2023 2699962131 Changed new business route
sai krishna 01/25/2023 2699962131 added batch name
sai krishna 01/31/2023 2698197526 changed delete Api
Suresh Peddavoora 01/31/2023 2698197526 Added Title for Table
sai krishna 01/31/2023 2698197526 integrated failed record api  and added approve reject functionality
Prakash 26/04/2023 2698197526 fixed icon issue
Ravi 05/31/2023 2698197526 changed delete popup message
uday  06/12/23 2698197526 fixed table alignment issue
*/
import React, {useEffect, useState, createRef, useContext} from 'react';
// import MaterialTable from "material-table";
import {
  resetStatusWorkQueueList,
} from '../../../../redux/reducers/WorkQueue';
import {setShowDashboardWorkQueue} from '../../../../redux/reducers/role';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router';
import {
  Button,
  TablePagination,
} from '@material-ui/core';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {httpPaginationDelete, httpPaginationPost} from '../../../../util/Rest';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {ArrowBack} from '@material-ui/icons';
import {fetchBatchAccounts} from '../../../../redux/reducers/accountBatch';
import BreadCrums from '../../../../util/BreadCrum';
import {
  postApproveBatch,
  postRejectBatch,
  resetMessage,
} from '../../../../redux/reducers/accountBatch';
// import WorkQueueList from "./Pages/Dashboard/WorkQueue/WorkQueueList";
const WorkQueueListTable = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [rows, setRows] = useState(defaultRows);
  const [isDelete, setIsDelete] = useState(false);
  const [headersFields, setHeadersFields] = useState([]);
  const [arrayLast, setArrayLast] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [status, setStatus] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [title, setTitle] = useState('');
  const [Description, setDescription] = useState('');
  const [isAction, setIsAction] = useState('');
  // const { values, submitForm, setFieldValue } = useFormikContext();
  useEffect(() => {
    dispatch(setShowDashboardWorkQueue(''));
  }, []);
  // const formattedFieldList = [
  //   { fieldCode: "ABBVBB", fieldHeader: "Balance", dataType: "text" },
  // ]?.map((field) => ({
  //   globalField: field?.fieldCode,
  //   repository: field?.fieldHeader,
  //   fieldType: field?.dataType ? field?.dataType : field?.fieldType,
  // }));
  const dispatch = useDispatch();
  const history = useHistory();
  const tableRef = createRef();
  const BatchName = history.location.state.BatchName;
  const BatchId = history.location.state.BatchId;
  const ClosedTab = history.location.state.closedBatch;
  const currentTab = history.location.state.tabValue;
  const count = history?.location?.state?.failedCount;
  const {workQueueListStatus} = useSelector(({workQueue}) => workQueue);
  // const [payloadData, setPayloadData] = useState({
  //   batchName: BatchName,
  //   limit: 5,
  //   orderBy: '',
  //   orderDirection: '',
  //   page: 0,
  // });
  const payloadData = {
    batchId: BatchId,
    limit: 5,
    orderBy: '',
    orderDirection: '',
    page: 0,
  };
  // const [payloadData1, setPayloadData1] = useState({
  //   batchName: BatchName,
  //   limit: 10,
  //   orderBy: '',
  //   orderDirection: '',
  //   page: 1,
  // });
  const payloadData1 = {
    batchName: BatchName,
    limit: 10,
    orderBy: '',
    orderDirection: '',
    page: 1,
  };
  //   const passValues = {
  //     batchName:BatchName,
  //     orderBy: "",
  //     orderDirection: "",
  //     limit: 5,
  //     page: 0,

  //   };
  //   setPayloadData(passValues);
  //   setStatus(true);
  // };

  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };

  const columns = [
    {
      title: 'Account Number',
      field: 'accountNumber',
      render: (rowData) => (
        <div
          className="wq-accountNumber"
          onClick={() => {
            dispatch(fetchBatchAccounts(rowData?.accountNumber, BatchId));
            history.push({
              pathname: `/new-business-maintenance/new-account-fields`,
              state: {
                fromAccountList: '/new-business-maintenance/new-account-fields',
                accountNumber: rowData?.accountNumber,
                BatchName: BatchName,
                closedBatch: ClosedTab === 'Yes' ? 'Yes' : 'No',
                tabValue: currentTab,
                BatchId:BatchId,
              },
            });
          }}
        >
          {rowData.accountNumber}
        </div>
      ),
    },
  ];

  const failedColumns = [
    {
      title: 'Batch Name',
      field: 'batchName',
    },
    {
      title: 'Code',
      field: 'dmCode',
    },
    {
      title: 'Account Data',
      field: 'recordJson',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              // textAlign: "justify",
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.recordJson}
          </div>
        </>
      ),
    },
    {
      title: 'Failed Reason',
      field: 'failedReason',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.failedReason}
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (workQueueListStatus === 200) {
      setTimeout(() => {
        resetStatusWorkQueueList();
      }, 2500);
    }
  }, [workQueueListStatus]);

  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (!headersFields) {
      history.push({
        pathname: `/account-summary`,
      });
    }
  }, [headersFields]);

  const {successMsg, errorMsg} = useSelector(({accountBatch}) => accountBatch);

  const {roleData} = useSelector(({role}) => role);
  const newBusinessAccess = roleData?.window?.['New Business Maintenance']?.['NBM'];

  const handleClose = () => {
    setIsDelete(false);
    setIsAction(false);
  };

  const handleSubmit = () => {
    httpPaginationDelete(`dmbatch/delete/batch/${BatchName}/${deleteData?.accountNumber}`)
      .then((response) => {
        if (response?.status === 200) {
          setMessage(response?.message ? 'Account Number Deleted Successfully' : '');
          setIsDelete(false);
          setStatus(true);
          setTimeout(() => {
            setMessage('');
          }, 3000);
        } else if (response?.data?.status === 500 || response?.data?.status === 400) {
          setError(response?.data?.message);
          setTimeout(() => {
            setError('');
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleApprove = () => {
    if (title === 'Approve Batch') {
      dispatch(postApproveBatch(BatchId));
    } else if (title === 'Reject Batch') {
      dispatch(postRejectBatch(BatchId));
    }
  };

  useEffect(() => {
    if (successMsg) {
      history.push({
        pathname: '/new-business',
        state: {
          closedBatch: ClosedTab === 'Yes' ? 'Yes' : 'No',
          tabValue: currentTab,
        },
      });
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg]);

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Account Number"
        value={`Are you sure you want to delete the ${deleteData?.accountNumber} Account Number?`}
        handleSubmit={handleSubmit}
      />
      <DeleteTableRecordPopup
        open={isAction}
        dialogClose={handleClose}
        title={title}
        value={Description}
        handleSubmit={handleApprove}
      />
      <div>
        <div>
          <div className={` ${classes.cardStyleWhite}`}>
            <div className="table-header mb-3 new-standard-textfields">
              <Button
                variant="outlined"
                type="button"
                className={`search-btn`}
                onClick={() => {
                  history.push({
                    pathname: '/new-business',
                    state: {
                      closedBatch: ClosedTab === 'Yes' ? 'Yes' : 'No',
                      tabValue: currentTab,
                      failedCount: false,
                    },
                  });
                }}
              >
                <ArrowBack className="mr-2" />
                Back to Batch List
              </Button>
              {/* <div className="mb-2 ml-1">
                  <BreadCrums
                    name={"BatchName"}
                    code={BatchName}

                  />
                </div> */}
            </div>
            <div className="work-queue-table global-field-table mui-custom-table-container new-standard-textfields text-left-table">
              {/* <div className="mb-2 ml-1">
                  <Button
                    variant="outlined"
                    type="button"
                    className={`search-btn mx-1`}
                    onClick={() => {
                      //setActionData(rowData)
                      setTitle("Approve Batch")
                      setDescription(`Are you sure you want to approve this ${BatchName} batch ?`)
                      setIsAction(true)
                    }}

                  >

                    Approve
                  </Button>
                  <Button
                    variant="outlined"
                    type="button"
                    className={`search-btn mx-1`}
                    onClick={() => {
                      //setActionData(rowData)

                      setTitle("Reject Batch")
                      setDescription(`Are you sure you want to reject this ${BatchName} batch ?`)
                      setIsAction(true)
                    }}

                  >

                    Reject
                  </Button>


                </div> */}
              <GuiTable
                title={
                  !count ? (
                    <div className="batch-name-title batch-name">
                      <BreadCrums name={'Batch Name'} code={BatchName} />
                    </div>
                  ) : (
                    ''
                  )
                }
                columns={count ? failedColumns : dynamicColumns}
                tableRef={tableRef}
                data={(query) =>
                  new Promise((resolve) => {
                    const url = `dmbatch/search/account/batchName`;
                    const url1 = `dmbatch/find/all/failed/record`;
                    const passValues = {
                      ...payloadData,
                      limit: query.pageSize ? query.pageSize : null,
                      page:
                        arrayLast && query?.page >= 1 ?
                          query.page :
                          arrayLast ?
                            (query.page <= 1 && query.page + 1) || query.page - 1 :
                            query.page + 1,
                    };
                    const passValues1 = {
                      ...payloadData1,
                      limit: query.pageSize ? query.pageSize : null,
                      page:
                        arrayLast && query?.page >= 1 ?
                          query.page :
                          arrayLast ?
                            (query.page <= 1 && query.page + 1) || query.page - 1 :
                            query.page + 1,
                    };
                    if (count === true) {
                      httpPaginationPost(url1, passValues1)
                        .then((response) => {
                          if (response?.status === 200) {
                            const data = response.data.response.resultObjects;
                            resolve({
                              data: data.length > 0 ? data : [],
                              page: response.data.response.page - 1,
                              totalCount: response.data.response.count,
                            });
                            // setArrayLast(response.data.response.resultObjects.length === 1);
                          } else {
                            resolve({
                              data: [],
                              page: 0,
                              totalCount: 5,
                            });
                            dispatch({
                              type: 'FETCH_ERROR',
                              payload: response && response.message ? response.message : null,
                            });
                          }
                        })
                        .catch((response) => {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        });
                    } else {
                      httpPaginationPost(url, passValues)
                        .then((response) => {
                          if (response?.status === 200) {
                            const tableData = [];
                            const headers = response.data.response.header;
                            const data = response.data.response.result;
                            console.log('order1', data);
                            setArrayLast(data.length === 1);
                            setHeadersFields(headers);

                            Object.keys(data[0].data).forEach((key) => {
                              Object.values(headers).forEach((val) => {
                                if (
                                  key === val?.fieldCode?.toLowerCase() &&
                                  val.fieldCode != 'ACCOUNT_NUMBER'
                                ) {
                                  columns.push({
                                    field: key,
                                    title: val?.fieldCode,

                                    // cellStyle: {
                                    //   textAlign: val?.dataType == "Number" ? "right" : "left",
                                    // },
                                  });
                                }
                              });
                              if (!columns.some((el) => el.field === key)) {
                                if (key != 'account_number') {
                                  columns.push({field: key, title: key});
                                }
                              }
                            });
                            dynamicColumns.length === 0 && setDynamicColumns(columns);
                            data.forEach((obj) => {
                              console.log('order', obj);
                              Object.keys(obj.data).forEach(function(key) {
                                if (obj.data[key] === 'null' || obj.data[key] === '') {
                                  obj.data[key] = '';
                                }
                              });
                              tableData.push({
                                accountNumber: obj.accountNumber,
                                ...obj.data,
                              });
                            });
                            resolve({
                              data: data.length > 0 ? tableData : [],
                              page: response.data.response.page - 1,
                              totalCount: response.data.response.count,
                            });
                            // setArrayLast(response.data.response.resultObjects.length === 1);
                          } else {
                            resolve({
                              data: [],
                              page: 0,
                              totalCount: 5,
                            });
                            dispatch({
                              type: 'FETCH_ERROR',
                              payload: response && response.message ? response.message : null,
                            });
                          }
                        })
                        .catch((response) => {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        });
                    }
                  })
                }
                options={{
                  search: false,
                  sorting: false,
                  pageSizeOptions: tablePageRows,
                  pageSize: rows,
                  emptyRowsWhenPaging: false,
                  toolbar: !count,
                  headerStyle: {
                    fontWeight: 'bold',
                    zIndex: 0,
                  },
                }}
                actions={
                  ClosedTab !== 'Yes' &&
                  !count && [
                    (rowData) => {
                      return {
                        icon: () => (
                          <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />
                        ),
                        disabled: !newBusinessAccess?.delete,
                        tooltip: 'Delete',
                        onClick: (event, rowData) => {
                          handleDelete(rowData);
                        },
                      };
                    },
                    {
                      icon: () => (
                        <>
                          <Button
                            variant="outlined"
                            disabled={!newBusinessAccess?.edit && !newBusinessAccess?.add}
                            className={`search-btn ${classes.buttonRoot}`}
                          >
                            Approve Batch
                          </Button>
                        </>
                      ),
                      disabled: !newBusinessAccess?.edit && !newBusinessAccess?.add,
                      isFreeAction: true,
                      onClick: (event) => {
                        setTitle('Approve Batch');
                        setDescription(
                            `Are you sure you want to approve this ${BatchName} batch ?`,
                        );
                        setIsAction(true);
                      },
                    },
                    {
                      icon: () => (
                        <>
                          <Button
                            variant="outlined"
                            disabled={!newBusinessAccess?.edit && !newBusinessAccess?.add}
                            className={`search-btn ${classes.buttonRoot}`}
                          >
                            Reject Batch
                          </Button>
                        </>
                      ),
                      disabled: !newBusinessAccess?.edit && !newBusinessAccess?.add,
                      isFreeAction: true,
                      onClick: (event) => {
                        setTitle('Reject Batch');
                        setDescription(`Are you sure you want to reject this ${BatchName} batch ?`);
                        setIsAction(true);
                      },
                    },
                  ]
                }
                components={{
                  Pagination: (props) => (
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  ),
                }}
              />
            </div>
          </div>
          {message && <SuccessSnackbar successMsg={message} />}
          {(error || errorMsg) && <ErrorSnackbar errorMsg={error || errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
        </div>
      </div>
    </>
  );
};

export default WorkQueueListTable;
